/**
 * 部屋詳細の大タイトル文字列を組み立てる。
 *
 * - `site.name` に `architectureName` が含まれている → 拠点名のみ
 *   (単棟系で拠点名に建築タイプ名が織り込まれているケース)
 * - `roomCode` が `architectureName` と一致 → 重複させず「拠点名 建築タイプ名」
 * - `roomCode` がある → 「拠点名 建築タイプ名 部屋番号」
 * - `roomCode` が無い → 「拠点名 建築タイプ名」
 */
export function buildRoomTitle(args: {
  siteName: string;
  architectureName: string;
  roomCode?: string | null;
}): string {
  const { siteName, architectureName, roomCode } = args;

  // MON 奄美大島 MON のようなケースに対処する
  if (architectureName && siteName.includes(architectureName)) {
    return siteName;
  }

  // 八ヶ岳1st CREA CREA のようなケースに対処する
  if (roomCode && roomCode === architectureName) {
    return `${siteName} ${architectureName}`;
  }

  if (roomCode) {
    // 伊豆1st SOWA SOWA 2001のようなケースに対処する
    if (roomCode.includes(architectureName)) {
      return `${siteName} ${roomCode}`;
    }
    return `${siteName} ${architectureName} ${roomCode}`;
  }
  return `${siteName} ${architectureName}`;
}
